<template>
    <div class="flex items-center flex-col z-5 relative">
        <div class="w-full h-2" :class="colorString ? ('bg-' + colorString) : null" :style="{backgroundColor: colorHex}"/>
        <tooltip v-if="description" bottom :text="description" :style="chipStyle">
            <chip :color="color" x-small class="rounded-t-none">{{ title }}</chip>
        </tooltip>
        <chip v-else :color="color" x-small class="rounded-t-none" :style="chipStyle">{{ title }}</chip>
    </div>
</template>

<script>
import Colorable from "../../mixins/Colorable";

    export default {
        name: "ChipLine",

        mixins: [Colorable],

        props: {
            title: {
                type: String,
                default: null,
            },

            description: {
                type: String,
                default: null,
            },

            color: {
                default: 'primary'
            },
        },

        computed: {
            chipStyle() {
                return {
                    position: 'absolute',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    top: 0
                }
            }
        }
    }
</script>